import { BillEvent, BillEventType } from './billEvent';

export enum PaymentTransactionType {
  RECEIVED = 'received', // Zahlungseingang
  SENT = 'sent'         // Zahlungsausgang
}

export interface PaymentTransaction {
  id: string;
  type: PaymentTransactionType;
  amount: number;
  personId?: string;     // ID of the person who made the payment
  personName?: string;   // Display name of the person
  reference?: string;    // Reference for bank statement reconciliation
  paymentMethod?: string; // e.g., "Überweisung", "Bar", "PayPal"
  description?: string;  // Optional description
  timestamp: Date;
  
  // Link to bill event for consistency
  billEventId: string;
  
  // Audit trail
  createdBy: string;     // User ID who recorded this transaction
  createdByName?: string; // Display name
  createdAt: Date;
  updatedAt: Date;
}

// Extend existing payment events to include transaction details
export interface EnhancedPaymentReceivedEvent extends BillEvent {
  type: BillEventType.PAYMENT_RECEIVED;
  details: {
    amount: number;
    totalPaidAmount: number;
    remainingAmount: number;
    paymentMethod?: string;
    reference?: string;
    // Enhanced details for transaction tracking
    personId?: string;
    personName?: string;
    description?: string;
    transactionId: string; // Link to PaymentTransaction
  };
}

export interface EnhancedPaymentSentEvent extends BillEvent {
  type: BillEventType.PAYMENT_SENT;
  details: {
    amount: number;
    recipient?: string;
    paymentMethod?: string;
    reference?: string;
    // Enhanced details for transaction tracking  
    personId?: string;
    personName?: string;
    description?: string;
    transactionId: string; // Link to PaymentTransaction
  };
}

// Helper function to create transaction ID
export const generateTransactionId = (): string => {
  return `txn_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// Helper function to get payment type display name in German
export const getPaymentTypeDisplayName = (type: PaymentTransactionType): string => {
  switch (type) {
    case PaymentTransactionType.RECEIVED:
      return 'Zahlungseingang';
    case PaymentTransactionType.SENT:
      return 'Zahlungsausgang';
    default:
      return 'Unbekannte Zahlung';
  }
};

// Helper function to get payment type color
export const getPaymentTypeColor = (type: PaymentTransactionType): 'success' | 'error' => {
  switch (type) {
    case PaymentTransactionType.RECEIVED:
      return 'success';
    case PaymentTransactionType.SENT:
      return 'error';
    default:
      return 'success';
  }
};